module.exports = __webpack_public_path__ + "img/maj5.39eb6ed1.jpg";